module.exports = __webpack_public_path__ + "img/zwdk.f3cc8942.png";